export const actionRead = 'read';
export const actionCreate = 'create';
export const actionDelete = 'delete';
export const actionUpsert = 'upsert';

export const permissionActions = [actionRead, actionCreate, actionDelete, actionUpsert] as const;
export type PermissionActions = typeof permissionActions[number];
